/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Hidden, Typography2, breakpoints } from '@coursera/cds-core';
import { LockIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/teams-v2';

const styles = {
  icon: css`
    margin-right: 4px;
  `,
  greyText: css`
    color: var(--cds-color-grey-600);
  `,
  lockIcon: css`
    display: flex;
    align-items: center;
    color: var(--cds-color-neutral-primary-invert);
  `,
  footerText: css`
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    bottom: 32px;
    width: 100%;
    max-width: 1116px;
    left: 50%;
    transform: translateX(-50%);
    padding: 0;

    ${breakpoints.down('sm')} {
      padding: 0 var(--cds-spacing-200);
    }
  `,
};

const TeamsFooter = () => {
  const currentYear = new Date().getFullYear();
  return (
    <Hidden smDown>
      <footer>
        <div css={styles.footerText}>
          <Typography2 variant="bodySecondary" component="span" css={styles.greyText}>
            {_t('© #{currentYear} Coursera Inc. All rights reserved.', { currentYear })}
          </Typography2>
          <span css={styles.lockIcon}>
            <LockIcon css={styles.icon} style={{ width: 16, height: 16 }} data-testid="lock-icon" />
            <Typography2 variant="bodySecondary" component="span" color="invertBody">
              {_t('Safe and secure')}
            </Typography2>
          </span>
        </div>
      </footer>
    </Hidden>
  );
};

export default TeamsFooter;
